// extracted by mini-css-extract-plugin
export default {"number":"RiskScore_number__1knJP","body":"RiskScore_body__-40xa"};